import React from 'react';

const Logo: React.FC = () => {
  return (
    <div className="text-xl font-bold">Ensemble</div>
  );
};

export default Logo;